import { openEntityDialog } from '@/constants/states';
import { saveStates } from '@/constants/lifecycle';
import { assignIfExists, assignValue } from '@/utils/resultsHelper';
import {
  alignFieldsToForm,
  assignFormLinksEditProps,
  assignFormObjectsEditProps,
  crushFormProps,
} from '@/forms/state/state';

export const activeRequestFieldArray = () => ({
  ...openEntityDialog,
  activeFieldName: '',
  activeIndex: '',
  items: [],
  isDirty: false,
  isEditing: false,
  linksOpen: false,
  ...saveStates,
});

export const requestObjectsDialogState = (
  requestFieldItems,
  items,
  isEditing,
  {
    activeIndex,
    activeFieldName,
    category,
    code,
    sections,
  },
) => {
  const props = {
    category, code, activeFieldName, activeIndex, open: true, items,
  };

  if (isEditing) {
    assignFormObjectsEditProps({ sections }, activeFieldName, items);
    props.isEditing = true;
  }

  assignIfExists(requestFieldItems, props);
};

export const requestLinksDialogState = (
  requestFieldItems,
  items,
  isEditing,
  {
    activeIndex,
    activeFieldName,
    category,
    code,
    sections,
  },
) => {
  if (isEditing) {
    assignFormLinksEditProps({ sections }, activeFieldName, items);
  }

  assignIfExists(requestFieldItems, {
    category, code, activeFieldName, activeIndex, linksOpen: true, items, isEditing: true,
  });
};

const crushRequestFields = (parent, form) => {
  const copy = crushFormProps(parent.fields);
  const { redundant } = alignFieldsToForm(copy, form);

  redundant.forEach((key) => delete copy[key]);
  assignValue(parent, 'fields', copy);
};

export default crushRequestFields;
